import { duplicateSelection } from "./sheet-operations";
import { SheetProperties } from "./SheetProperties";
import { CadDrawingControls } from "./CadDrawingControls";
import { Lock, Trash2, Copy } from "lucide-react";
import { markLabel } from "./shapes";

import type { WorkspaceModel } from "./useWorkspace";
export function Inspector({ model }: { model: WorkspaceModel }) {
  const { editor, selected, active, canEdit } = model;
  return (
    <>
      {active && (
        <aside className="inspector">
          <CadDrawingControls key={active.id} model={model} sheet={active} />
          <div className="inspector-section">
            <SheetProperties model={model} sheet={active} />
            {canEdit &&
              editor.getCurrentPageShapes().some((s) => s.isLocked) && (
                <button
                  className="calibrate-button"
                  onClick={() =>
                    editor.updateShapes(
                      editor
                        .getCurrentPageShapes()
                        .filter((s) => s.isLocked)
                        .map((s) => ({
                          id: s.id,
                          type: s.type,
                          isLocked: false,
                        })),
                    )
                  }
                >
                  Unlock board items
                </button>
              )}
          </div>
          {selected[0]?.type === "mark" && (
            <div className="inspector-section">
              <div className="property-row">
                <span>{selected[0].props.kind}</span>
                <strong>
                  {markLabel(selected[0], active.props.metersPerUnit)}
                </strong>
              </div>
            </div>
          )}
          {canEdit && selected.length > 0 && (
            <div className="selection-actions">
              <button
                title="Duplicate selection"
                aria-label="Duplicate selection"
                onClick={() => duplicateSelection(editor)}
              >
                <Copy size={15} />
              </button>
              <button
                title="Lock selection"
                aria-label="Lock selection"
                onClick={() => {
                  const ids = editor.getSelectedShapeIds();
                  editor.toggleLock(ids);
                  editor.select(...ids);
                }}
              >
                <Lock size={15} />
              </button>
              <button
                title="Delete selection"
                aria-label="Delete selection"
                onClick={() =>
                  editor.deleteShapes(editor.getSelectedShapeIds())
                }
              >
                <Trash2 size={15} />
              </button>
            </div>
          )}
        </aside>
      )}
    </>
  );
}
